/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clubs_Start_Five_ProgressInputs */

const en_us2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of 5`)
};

const pt_br2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de 5`)
};

const es_419_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de 5`)
};

const pt_pt2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de 5`)
};

const fr_fr2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sur 5`)
};

const de_de2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von 5`)
};

const it_it2_clubs_start_five_progress = /** @type {(inputs: Clubs_Start_Five_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} su 5`)
};

/**
* | output |
* | --- |
* | "{count} of 5" |
*
* @param {Clubs_Start_Five_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_start_five_progress = /** @type {((inputs: Clubs_Start_Five_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Start_Five_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_start_five_progress(inputs)
	if (locale === "es-419") return es_419_clubs_start_five_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_start_five_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_start_five_progress(inputs)
	if (locale === "de-DE") return de_de2_clubs_start_five_progress(inputs)
	if (locale === "it-IT") return it_it2_clubs_start_five_progress(inputs)
	return en_us2_clubs_start_five_progress(inputs)
});
export { clubs_start_five_progress as "clubs.start_five_progress" }